import SearchResultContainer from "../../../Components/Applications/SearchResult/SearchResultContainer";

const SearchResult = () => {
  return <SearchResultContainer />;
};

export default SearchResult;
